export class Sonda {
	codigo:string;
	nome:string;
	ativo?:boolean;
	sincronizado?:boolean;
	dataSincronizacao?:String;
}
